import React from 'react';
import PropTypes from 'prop-types';
import Icon from 'components/icon';
import ExternalLink from 'components/link/external';
import { formatDate } from 'utils';
import { renderMarkdown } from 'utils/string';
import { getAppDeveloperUrl } from 'utils/app';

import './storefront.scss';

export default class StorefrontNewAppDeveloper extends React.PureComponent {
  static propTypes = {
    app: PropTypes.object.isRequired,
  };

  render() {
    const { app } = this.props;

    const owner = app.partner || app.client;
    const location = [owner.business?.city, owner.business?.country]
      .filter(Boolean)
      .join(', ');
    const developerUrl = getAppDeveloperUrl(app, owner);

    return (
      <div className="storefront-apps-view-developer">
        <div className="storefront-apps-view-banner">
          <div className="storefront-apps-view-header">
            <div className="storefront-apps-view-title">
              <h3>{owner.name}</h3>
            </div>
            <div className="storefront-apps-view-header-details">
              {app.support_docs && (
                <div className="storefront-apps-view-header-detail">
                  <ExternalLink href={app.support_docs} icon={false}>
                    <Icon fa="book-open" /> View documentation
                  </ExternalLink>
                </div>
              )}
              {developerUrl && (
                <div className="storefront-apps-view-header-detail">
                  <ExternalLink href={developerUrl} icon={false}>
                    <Icon fa="life-ring" />{' '}
                    {app.supported ? 'Get support' : 'Website'}
                  </ExternalLink>
                </div>
              )}
              {location && (
                <div className="storefront-apps-view-header-detail">
                  <span>
                    <Icon fa="location-dot" /> {location}
                  </span>
                </div>
              )}
              {app.partner && (
                <div className="storefront-apps-view-header-detail">
                  <span>
                    <Icon fa="circle-heart" /> Partner since{' '}
                    {formatDate(app.partner.date_created, 'month')}
                  </span>
                </div>
              )}
            </div>
          </div>
          {app.release_notes?.length > 0 && (
            <div className="storefront-apps-view-developer-release-notes">
              <h3>Latest release</h3>
              {renderMarkdown(app.release_notes)}
            </div>
          )}
        </div>
      </div>
    );
  }
}
